export const DropdownConstants = Object.freeze({
  ALIGN_LEFT: 'left',
  ALIGN_RIGHT: 'right',
  ALIGN_TOP: 'top',
  ALIGN_BOTTOM: 'bottom',
  HOVER_SHIELD_SIZE_PX: 30,
} as const);

export const DROPDOWN_KEY = 'dropdown';

export default DropdownConstants;
